module.exports = __webpack_public_path__ + "static/media/add-square.0a9514a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add-square.svg
// module id = 1410
// module chunks = 1